import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import MainApi from "../../../../../../services/mainApi.service";
import { memo, useMemo, useState } from "react";
import { IAppointmentArrivalConfigs } from "../../../../../../models/appointment-arrival-config";
import { AppointmentArrivalConfig } from "./AppointmentArrivalConfigForm/AppointmentArrivalConfig";

const APPOINTMENT_ARRIVAL_CONFIG_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/AppointmentArrivalRuleConfig/";
const appointmentArrivalConfigService = new MainApi<IAppointmentArrivalConfigs>(
  APPOINTMENT_ARRIVAL_CONFIG_ROUTE,
);

const translationPath =
  "chatBot.page.service.appointmentArrivalRule.appointmentArrivalConfig.";

export const AppointmentArrivalConfigPage = memo(() => {
  const { id: appointmentArrivalConfigId } = useParams();

  const { t } = useTranslation();

  const [iServiceForm, setIServiceForm] = useState(false);

  const [selectedId, setSelectedId] = useState<string>();

  const [rows, setRows] = useState<IAppointmentArrivalConfigs[]>([]);

  const columns: GridColDef<IAppointmentArrivalConfigs>[] = [
    {
      field: "timeStart",
      headerName: t(translationPath + "from") || "From",
      renderCell: (params) => {
        if (!params.value) return "-";
        return (
          <OverflowTooltip
            text={params.value}
            tooltip={params.value}
            textTransform="none"
            variant="body2"
          />
        );
      },
    },
    {
      field: "timeEnd",
      headerName: t(translationPath + "to") || "To",
      renderCell: (params) => {
        if (!params.value) return "-";
        return (
          <OverflowTooltip
            text={params.value}
            tooltip={params.value}
            textTransform="none"
            variant="body2"
          />
        );
      },
    },
    {
      field: "arrivalTime",
      headerName: t(translationPath + "arrival_time") || "Arrival Time",
      renderCell: (params) => {
        if (!params.value) return "-";
        return (
          <OverflowTooltip
            text={params.value}
            tooltip={params.value}
            textTransform="none"
            variant="body2"
          />
        );
      },
    },
  ];

  const handleAdd = () => {
    setIServiceForm(true);
  };

  const handleRowClick = (
    params: GridRowParams<IAppointmentArrivalConfigs>,
  ) => {
    if (!params.row) return;
    setIServiceForm(true);
    setSelectedId(params.row.id);
  };

  const handleBack = () => {
    setSelectedId(undefined);
    setIServiceForm(false);
  };

  const params = useMemo(() => {
    return {
      appointmentArrivalRuleId: appointmentArrivalConfigId,
    };
  }, [appointmentArrivalConfigId]);

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {iServiceForm && (
        <Box
          sx={(t) => ({
            p: 1,
            px: 10,
            height: "100%",
            overflow: "auto",
            backgroundColor: t.palette.background.default,
            borderRadius: 1,
          })}
        >
          <AppointmentArrivalConfig
            id={selectedId}
            appointmentArrivalConfigId={appointmentArrivalConfigId}
            onBackButton={handleBack}
          />
        </Box>
      )}
      {!iServiceForm && (
        <Box height={600}>
          <Table<IAppointmentArrivalConfigs>
            showDefaultMacroFilters={false}
            service={appointmentArrivalConfigService}
            serviceProps={params}
            onFetchData={(data) => {
              setRows(data);
            }}
            onFetchDelete={(data) => {
              const filterdRows = rows.filter((item) => item.id !== data?.id);
              setRows(filterdRows);
            }}
            columns={columns}
            title={t(translationPath + "appointment_arrival_configs")}
            searchInput
            onAdd={handleAdd}
            onRowClick={handleRowClick}
            searchInputPlaceHolder={t(translationPath + "search")}
            addButtonLabel={
              t(translationPath + "add_appointment_arrival_config") ||
              "Add Appointment Arrival Config"
            }
            confirmOptions={{
              title: t(translationPath + "confirm.title"),
              description: t(translationPath + "confirm.description"),
              confirmationButtonProps: {
                variant: "contained",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
});
